export default {
    wallet: "Wallet",
    "rock-content-credits": "Rock Content Credits",
    "selected-wallet": "Selected wallet",
    "select-wallet": "Select wallet",
    "credits-about-to-expire": "Credits about to expire",
    "transaction-statements": "Transaction Statement",
    "all-transactions-carried": "All transactions carried out on your wallet",
    "all-transactions": "All Transactions",
    "no-transactions": "No transactions available",
    edded: "Added",
    spent: "Spent",
    date: "Date",
    credits: "Credits",
    description: "Description",
};
